
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/donate",
      function () {
        return require("private-next-pages/[domain]/donate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/donate"])
      });
    }
  